// extracted by mini-css-extract-plugin
export default {"PortfolioPage":"style_PortfolioPage__F7Hqx"};